import gql from 'graphql-tag';
import camelCase from 'lodash/camelCase';

const getJobsQuery = (locale) => gql`
  query Jobs(
    $category: String,
    $limit: Int,
    $offset: Int,
    $locales: [String]!,
    $highlightLocale: String,
    $highlightType: HighlightPeriodType
    $imageConfigurations: [ResponsiveImageConfiguration],
  )
  {
    jobs (
      category: $category,
      limit: $limit,
      offset: $offset,
      locales: $locales,
      highlightLocale: $highlightLocale,
      highlightType: $highlightType
    ) {
      id
      title
      city
      urls {
        ${camelCase(locale)}
      }
      company {
        name
        displayName
        logoUrls(configurations: $imageConfigurations)
        description
        imageUrls(configurations: $imageConfigurations)
      }
    }
  }
`;

export default getJobsQuery;
